import React, { type FC, type ReactNode, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import type { TextStylesType } from 'shared/ui'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { type BooleanSwitchOption } from 'pages/settings/pages/doubleOptIn/store/doubleOptInPageStore'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'

interface IDoubleOptInSettingProps {
  title: string
  titleVariant?: TextStylesType
  titleRightContent?: ReactNode
  description?: string | ((value?: boolean) => string)
  learnMoreLink?: string
  option: BooleanSwitchOption
  disabled?: boolean
  renderContent?: (value?: boolean) => ReactNode
  className?: string
}

export const DoubleOptInSetting: FC<IDoubleOptInSettingProps> = observer(
  ({
    title,
    titleVariant,
    titleRightContent,
    description,
    learnMoreLink,
    option,
    disabled,
    renderContent,
    className,
  }: IDoubleOptInSettingProps) => {
    const store = useContext(DoubleOptInPageContext)

    if (!store) return null

    const checked = Boolean(store[option])

    return (
      <DoubleOptInSettingLayout
        title={title}
        titleVariant={titleVariant}
        titleRightContent={titleRightContent}
        description={description}
        learnMoreLink={learnMoreLink}
        checked={checked}
        onToggle={(value) => store.handleBooleanSwitcher(option, value)}
        disabled={disabled || store.switchLoadingMap[option]}
        renderContent={renderContent}
        className={className}
      />
    )
  }
)
